import { render, staticRenderFns } from "./FormInputZip.vue?vue&type=template&id=13c1d48c&"
import script from "./FormInputZip.vue?vue&type=script&lang=js&"
export * from "./FormInputZip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/madamesumcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13c1d48c')) {
      api.createRecord('13c1d48c', component.options)
    } else {
      api.reload('13c1d48c', component.options)
    }
    module.hot.accept("./FormInputZip.vue?vue&type=template&id=13c1d48c&", function () {
      api.rerender('13c1d48c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/madamesum/js/components/FormInputZip.vue"
export default component.exports